import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-713476fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Configuration", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Edit", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "New application", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Result", -1))
const _hoisted_5 = { class: "result" }

import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { MdmPolicySchema, PolicySchema } from '@/generated/sdk'
import { merge, formatPolicy, getPoliciesToUpdate } from './policy.utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'PolicyConfiguration',
  setup(__props) {

const store = useStore()

const currentPolicy = computed<MdmPolicySchema>(
  () => store.state.policies.currentPolicy,
)

const policies = computed<MdmPolicySchema[]>(
  () => store.state.policies.mdmPolicies,
)

const possibleParentPolicies = computed<MdmPolicySchema[]>(() =>
  policies.value.filter(
    policy =>
      policy.id !== currentPolicy.value.id && // Not itself
      !getParents(policy).find(parent => parent.id === currentPolicy.value.id), // Nor it's children
  ),
)

const jsonHasError = computed<boolean>(() => {
  try {
    JSON.parse(input.value)
    return false
  } catch (e) {
    return true
  }
})

const jsonView = ref<boolean>(true)
const input = ref<string>(formatPolicy(currentPolicy.value.configPolicy))
const parentId = ref<string>(currentPolicy.value.parent?.id)

function getParents(mdmPolicy: MdmPolicySchema): MdmPolicySchema[] {
  const parent = getParent(mdmPolicy)
  if (!parent) return []
  return [parent].concat(getParents(parent))
}

function getParent(mdmPolicy: MdmPolicySchema): MdmPolicySchema | null {
  return policies.value.find(m => m.id === mdmPolicy.parent?.id)
}

async function updatePolicy() {
  // Get the new config and connect it to the cloned policy
  const newConfigPolicy: PolicySchema = JSON.parse(input.value)
  const clonedMdmPolicies: MdmPolicySchema[] = JSON.parse(
    JSON.stringify(policies.value),
  )
  const clonedMdmPolicy = clonedMdmPolicies.find(
    p => p.id === currentPolicy.value.id,
  )

  clonedMdmPolicy.configPolicy = newConfigPolicy

  clonedMdmPolicy.parent = parentId.value
    ? ({ id: parentId.value } as MdmPolicySchema)
    : null

  // Re-generate all policies with the new config
  for (const mdmPolicy of clonedMdmPolicies) {
    mdmPolicy.policy = merge(mdmPolicy, clonedMdmPolicies)
  }

  // Get all policies to update
  const policiesToUpdate = await getPoliciesToUpdate(
    policies.value.map(p => p.policy),
    clonedMdmPolicies.map(p => p.policy),
  )

  if (policiesToUpdate.length === 0) {
    alert('No policies to update')
  } else {
    if (
      confirm(
        `Update ${policiesToUpdate.length} policies? (This will only succeed if the config policy is valid)`,
      )
    ) {
      // First update our policy (may still fail validation)
      await store.dispatch(
        'updatePolicies',
        [clonedMdmPolicy.configPolicy].concat(policiesToUpdate),
      )
    }
  }

  // Always update the parent
  await store.dispatch('updateMdmPolicy', clonedMdmPolicy)
}

return (_ctx: any,_cache: any) => {
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_PrimeDropdown = _resolveComponent("PrimeDropdown")!
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_PrimePanel = _resolveComponent("PrimePanel")!
  const _component_DodoIcon = _resolveComponent("DodoIcon")!
  const _component_PrimeTextarea = _resolveComponent("PrimeTextarea")!
  const _component_DodoColumn = _resolveComponent("DodoColumn")!
  const _component_PackageForm = _resolveComponent("PackageForm")!
  const _component_SplitterPanel = _resolveComponent("SplitterPanel")!
  const _component_PrimeSplitter = _resolveComponent("PrimeSplitter")!
  const _component_PlayStore = _resolveComponent("PlayStore")!

  return (_openBlock(), _createBlock(_component_DodoColumn, null, {
    default: _withCtx(() => [
      _createVNode(_component_DodoRow, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_DodoRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_PrimePanel, {
            header: "Parent",
            toggleable: "",
            class: "panel"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DodoRow, { gap: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_PrimeDropdown, {
                    modelValue: parentId.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((parentId).value = $event)),
                    class: "dropdown",
                    options: possibleParentPolicies.value,
                    loading: possibleParentPolicies.value == null,
                    "show-clear": true,
                    "option-value": "id",
                    "option-label": "name",
                    placeholder: "Select a parent policy"
                  }, null, 8, ["modelValue", "options", "loading"]),
                  _createVNode(_component_DodoButton, {
                    variant: "solid",
                    color: "info",
                    disabled: jsonHasError.value,
                    onClick: updatePolicy
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Save ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DodoRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_PrimePanel, {
            header: "Settings",
            toggleable: "",
            class: "panel"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimeSplitter, null, {
                default: _withCtx(() => [
                  _createVNode(_component_SplitterPanel, { class: "mdm-l-panel" }, {
                    default: _withCtx(() => [
                      (jsonView.value)
                        ? (_openBlock(), _createBlock(_component_DodoColumn, {
                            key: 0,
                            padding: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DodoRow, null, {
                                default: _withCtx(() => [
                                  _hoisted_2,
                                  _createVNode(_component_DodoRow, {
                                    grow: "",
                                    justify: "end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DodoButton, {
                                        variant: "solid",
                                        rounded: "",
                                        color: "success",
                                        disabled: jsonHasError.value,
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (jsonView.value = false))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DodoIcon, { name: "add" }),
                                          _createTextVNode(" Add application config ")
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DodoRow, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DodoColumn, { grow: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_PrimeTextarea, {
                                        modelValue: input.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((input).value = $event)),
                                        rows: "20",
                                        style: {"width":"100%"},
                                        class: _normalizeClass({ 'p-invalid': jsonHasError.value })
                                      }, null, 8, ["modelValue", "class"]),
                                      _createVNode(_component_DodoButton, {
                                        variant: "solid",
                                        color: "info",
                                        disabled: jsonHasError.value,
                                        onClick: updatePolicy
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Save ")
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_DodoColumn, {
                            key: 1,
                            padding: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DodoRow, {
                                grow: "",
                                justify: "space-between"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_3,
                                  _createVNode(_component_DodoRow, {
                                    grow: "",
                                    justify: "end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DodoButton, {
                                        variant: "solid",
                                        rounded: "",
                                        color: "danger",
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (jsonView.value = true))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DodoIcon, { name: "close" }),
                                          _createTextVNode(" Cancel ")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DodoRow, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_PackageForm, {
                                    config: input.value,
                                    "onUpdate:config": [
                                      _cache[4] || (_cache[4] = ($event: any) => ((input).value = $event)),
                                      _cache[5] || (_cache[5] = ($event: any) => (jsonView.value = true))
                                    ]
                                  }, null, 8, ["config"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SplitterPanel, { class: "mdm-l-panel" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DodoColumn, { padding: "6" }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _createElementVNode("pre", _hoisted_5, [
                            _createTextVNode("                "),
                            _createElementVNode("code", null, _toDisplayString(_unref(formatPolicy)(currentPolicy.value.policy)), 1),
                            _createTextVNode("\n              ")
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DodoRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_PrimePanel, {
            header: "Play store",
            toggleable: "",
            class: "panel"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PlayStore)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})